import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Button, CardBody, Input, Label } from "reactstrap";
import { Submit } from "../../../../Constant";

const DefaultForm = ({ images, setImages }) => {
    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);
        setImages(files);
    };

    return (
        <CardBody>
            <div className="pt-3">
                <Label className="form-label">Upload Images</Label>
                <Input
                    type="file"
                    multiple
                    accept="image/*"
                    onChange={handleImageChange}
                />

                <div className="mt-3 d-flex flex-wrap gap-2">
                    {images.map((img, i) => (
                        <img
                            key={i}
                            src={URL.createObjectURL(img)}
                            alt="preview"
                            style={{ width: 70, height: 70, objectFit: "cover", borderRadius: 5 }}
                        />
                    ))}
                </div>
            </div>

            <div className="pt-4 text-end">
                <span className="ps-2 spinner-enable">
                    <Button className="btn" type="submit">{Submit}</Button>
                </span>
            </div>
        </CardBody>
    );
};


export default DefaultForm;
